var render = function render(){var _vm=this,_c=_vm._self._c;return _c('category-menu-group-orders',{attrs:{"company":_vm.company}})
}
var staticRenderFns = []

export { render, staticRenderFns }